
import React, { useEffect, useState } from 'react';
import UsageCard from './components/usageCard.jsx';
import UsageSummaryCard from './components/usageSummaryCard.jsx';
import arrowForwardIcon from '../../../../../../assets/image/arrow-forward-icon.svg';
import { getPlanUsages } from '../../../../../../services/settings/subscriptions/index.js';
import Button from '../../../../../../component/ui/Button.jsx';


const calculateOverallUsage = (planUsages = {}) => {
  const values = Object.values(planUsages);

  let totalAllowed = 0;
  let totalConsumed = 0;

  values.forEach((item) => {
    const allowed = item.total_allowed;

    // Ignore unlimited features
    if (allowed === "unlimited") return;

    // Boolean features (enabled/disabled)
    if (typeof allowed === "boolean") {
      if (allowed) {
        totalAllowed += 1;
        totalConsumed += item.total_consumed ? 1 : 0;
      }
      return;
    }

    // Numeric values stored as strings
    const numericAllowed = Number(allowed);

    if (!isNaN(numericAllowed) && numericAllowed > 0) {
      totalAllowed += numericAllowed;
      totalConsumed += Number(item.total_consumed || 0);
    }
  });

  const percentage =
    totalAllowed > 0
      ? Math.round((totalConsumed / totalAllowed) * 100)
      : 0;

  return {
    totalAllowed,
    totalConsumed,
    percentage,
  };
};

export default function PlanUsagePage({ subscription, setSubscriptionScreenType }) {
  const [usages, setUsages] = useState(null)
  const [loading, setLoading] = useState(false)
  const [overallUsages, setOverallUsages] = useState(0)


  async function fetchPlanUsages() {
    try {
      setLoading(true)
      const data = await getPlanUsages()
      const usage = calculateOverallUsage(data);
      setUsages(data)
      setOverallUsages(usage)
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }


  useEffect(() => {
    fetchPlanUsages()
  }, [])

  if (!subscription && !loading) {
    return <div className="text-center py-5">No usage information found.</div>;
  }

  return (
    <div
      style={{
        height: "calc(100vh - 50px)",
        overflowY: "auto",
        overflowX: "hidden",
      }}
    >

      <div style={{ backgroundColor: '#EDEDF7', position: 'sticky', top: 0, zIndex: 100 }}>
        <div className="d-flex py-3 px-2 justify-content-between align-items-center">
          <div className="d-flex justify-content-start align-items-center gap-3">
            <div
              className="fs-4 fw-semibold cursor-pointer"
              onClick={() => setSubscriptionScreenType('subscription')}
            >
              My Subscription
            </div>
            <img
              width={12}
              height={12}
              src={arrowForwardIcon}
              alt="arrow-icon"
            />
            <div className="fs-4 fw-semibold">View Usage</div>
          </div>
          <div className="d-flex px-3">
            <Button
              type="button"
              className="mt-0 btn-danger fs-5 fw-light add-pro py-1"
              button=""
              close
              onClick={() => setSubscriptionScreenType('subscription')}
            />
          </div>
        </div>
      </div>

      <div className="container-fluid p-4">
        <div className="mb-4">
          <div className="fs-2 fw-bold">Plan Usage</div>

          <div className="text-muted fs-5">Monitor your subscription usage and remaining limits.</div>
        </div>

        <UsageSummaryCard
          subscription={subscription}
          overallUsage={overallUsages}
        />

        <div className="row mt-4">
          {Object.entries(usages || {}).map(([key, value]) => (
            <div
              key={key}
              className="col-lg-6 mb-4"
            >
              <UsageCard
                title={key}
                data={value}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
